import { type CatalogCopy, defaultCatalogCopy } from "@loot-os/api-contract";
import { useCurrency } from "../../../../lib/currency.js";
import { useTerminology } from "../../../../lib/terminology.js";

/** The catalog's words (`defaultCatalogCopy`), in the store's terms and currency. */
export function useCatalogCopy(): CatalogCopy {
  const currency = useCurrency();
  return defaultCatalogCopy({
    terms: useTerminology(),
    currencyPlural: currency.namePlural || currency.name,
  });
}
